var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"content",staticClass:"story full-h"},[_c('div',{staticClass:"row full-h"},[_c('div',{staticClass:"column-center full-w"},[_vm._t("header"),_vm._t("content")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }